import { ReactNode } from "react";
import styled from "styled-components";
import PublicPageHeader from "../../organism/PublicPageHeader";
import PublicPageFooter from "../../molecule/PublicPageFooter";

interface SignUpLayoutProps {
  children?: ReactNode;
}

function SignUpLayout({ children }: SignUpLayoutProps) {
  return (
    <Layout>
      <PublicPageHeader />
      <Flex>{children}</Flex>
      <PublicPageFooter />
    </Layout>
  );
}

export default SignUpLayout;

const Layout = styled.div`
  min-width: 1250px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Flex = styled.div`
  flex: 1;
`;
